module.exports = "/img/not-found.png?a67fd5e9a8e8288b23f918ddaf83cd7e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/not-found.png
// module id = EtaB
// module chunks = 72